import Grid from '@material-ui/core/Grid';
import styled from 'styled-components';

export const GridItem = styled(Grid).attrs({
  item: true,
})`
  align-self: baseline;
  padding-bottom: 0 !important;
  padding-top: 0 !important;
`;

export const GridContainer = styled(Grid).attrs({
  container: true,
  spacing: 24,
})`
  margin-bottom: 0;
  margin-top: 0;
`;

export default GridContainer;



// WEBPACK FOOTER //
// ./src/modules/common/Grid.js